import React, { useEffect, useState } from "react";
import { productService } from "../../services/product.service";
import ProductCard from "../../components/common/ProductCard";
import "./RecentlyLaunched.css";
// import inverterImage from "../../assets/images/inverter.png"; // Ensure this path is correct

const RecentlyLaunched = ({
  showcaseCategories = [],
  toUrlFriendly,
  onNavigate,
  onAddToCart,
  // NEW: Accept the cart props
  cartItems,
  onQuantityChange,
  onRemoveItem,
  favouriteItems
}) => {
  const [products, setProducts] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRecentlyLaunched = async () => {
      try {
        const data = await productService.getByDisplayFlag("recently_launched");
        setProducts(data);
      } catch (err) {
        console.error(err);
        setError("Failed to load recently launched products");
      } finally {
        setLoading(false);
      }
    };

    fetchRecentlyLaunched();
  }, []);

  if (loading) return null;
  if (error) return <p className="error-text">{error}</p>;

  return (
    <section className="page-section section-reveal visible">
      <h2 className="section-title">Recently Launched</h2>

      <div className="showcase-section">
        {/* LEFT SIDE */}
        <div className="showcase-left">
          <div className="showcase-banner">
            <h2>Latest Technology</h2>
            <p>New launches you’ll love</p>
            <button onClick={() => onNavigate("shop")}>Shop Now</button>
          </div>

          {/* NEW: High-Animation Inverter Promo Card */}
          <div className="animated-inverter-card" onClick={() => onNavigate("inverters")}>
            <div className="card-shine"></div> {/* Sweeping light effect */}
            <div className="glow-effect"></div> {/* Pulsing background glow */}
            
            <div className="badge-pulse">Next-Gen Power</div>
            
            <div className="inverter-image-container">
              {/* IMPORTANT: Put your transparent Inverter PNG link here! */}
              <img 
                src="https://res.cloudinary.com/dhbjxspxa/image/upload/v1772551633/Gemini_Generated_Image_1nh0x01nh0x01nh0_lainmb.png"
                alt="Zynventics Smart Inverter" 
                className="floating-inverter"
              />
            </div>

            <div className="inverter-text">
              <h3>Zynventics Inverters</h3>
              <p>Pure Sine Wave. Zero Interruptions.</p>
              <span className="explore-btn">Discover Now <span className="arrow">&rarr;</span></span>
            </div>
          </div>

        </div>

        {/* RIGHT SIDE (PRODUCT GRID) */}
        <div className="showcase-right">
          <div className="product-grid">
            {products.map((product) => (
              <ProductCard
                key={product.product_id}
                product={product}
                productId={product.product_id}
                onNavigate={onNavigate}
                onAddToCart={onAddToCart}
                
                // NEW: Pass the props down to the card
                cartItems={cartItems}
                onQuantityChange={onQuantityChange}
                onRemoveItem={onRemoveItem}
                favouriteItems={favouriteItems}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecentlyLaunched;